import GetAccountStarted from '../../../../Assets/Images/get-account-started.png';
import SubscriptionNotStarted from '../../../../Assets/Images/subs-not-started.png';
import i18n from 'src/i18n';

export let emptyUserListConstants = {
  getStarted: {
    img: GetAccountStarted,
    heading: i18n.t('getStartedHeading'),
    text: i18n.t('getStartedText'),
    customerUsers: {
      btnText: i18n.t('getStartedAddAdmin'),
    },
    accountUsers: {
      btnText: i18n.t('getStartedAddMember'),
    },
  },
  subsNotStarted: {
    img: SubscriptionNotStarted,
    heading: i18n.t('subsNotStartedHeading'),
    text: i18n.t('subsNotStartedText') + " ",
  }
};

i18n.on('languageChanged', function() {
  updateTranslations();
});

function updateTranslations () {
  emptyUserListConstants = {
    getStarted: {
      img: GetAccountStarted,
      heading: i18n.t('getStartedHeading'),
      text: i18n.t('getStartedText'),
      customerUsers: {
        btnText: i18n.t('getStartedAddAdmin'),
      },
      accountUsers: {
        btnText: i18n.t('getStartedAddMember'),
      },
    },
    subsNotStarted: {
      img: SubscriptionNotStarted,
      heading: i18n.t('subsNotStartedHeading'),
      text: i18n.t('subsNotStartedText') + " ",
    }
  };
}
